var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1957_42525)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 45,
    height: 45,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0553 25.9946C23.8603 25.8096 23.6893 25.6546 23.5253 25.4946C21.5653 23.5373 19.6059 21.5789 17.6473 19.6196C17.4331 19.4157 17.2647 19.1687 17.1532 18.8949C17.0417 18.621 16.9897 18.3267 17.0006 18.0312C17.0115 17.7357 17.085 17.446 17.2163 17.181C17.3476 16.9161 17.5337 16.6821 17.7623 16.4946C18.1639 16.1577 18.6778 15.9847 19.2013 16.0103C19.7248 16.0359 20.2194 16.2582 20.5863 16.6326C22.4589 18.4993 24.3286 20.3659 26.1953 22.2326C26.4603 22.4976 26.7213 22.7656 26.9953 23.0416L29.3673 20.6696C30.7106 19.3269 32.0546 17.9849 33.3993 16.6436C33.6639 16.3561 34.0069 16.1524 34.386 16.0577C34.765 15.963 35.1635 15.9814 35.5323 16.1106C35.9042 16.216 36.2375 16.4272 36.4915 16.7185C36.7456 17.0099 36.9095 17.3688 36.9633 17.7516C37.0271 18.0932 37.0029 18.4455 36.8929 18.7751C36.7828 19.1047 36.5906 19.4009 36.3343 19.6356C34.6009 21.3642 32.8696 23.0942 31.1403 24.8256C30.7533 25.2116 30.3643 25.5946 29.9653 25.9886C30.0343 26.0616 30.0833 26.1166 30.1353 26.1686C32.2019 28.2353 34.2686 30.3019 36.3353 32.3686C36.714 32.7233 36.948 33.2057 36.9921 33.7227C37.0363 34.2398 36.8874 34.7548 36.5743 35.1686C36.3943 35.4082 36.1648 35.6062 35.9014 35.749C35.638 35.8919 35.3468 35.9763 35.0478 35.9964C34.7488 36.0165 34.4491 35.9719 34.1689 35.8656C33.8887 35.7594 33.6347 35.5939 33.4243 35.3806C32.0623 34.0346 30.7143 32.6806 29.3593 31.3236L26.9593 28.9336C26.9151 29.0136 26.8636 29.0892 26.8053 29.1596C24.7386 31.2263 22.6719 33.2909 20.6053 35.3536C20.3416 35.6416 19.9997 35.8465 19.6215 35.9435C19.2433 36.0405 18.845 36.0252 18.4753 35.8996C18.1061 35.7986 17.7739 35.593 17.519 35.3075C17.264 35.022 17.0971 34.6688 17.0383 34.2906C16.9666 33.9429 16.9865 33.5826 17.0961 33.245C17.2056 32.9073 17.4011 32.6039 17.6633 32.3646C19.5493 30.4812 21.4346 28.5976 23.3193 26.7136C23.5523 26.4796 23.7863 26.2576 24.0553 25.9946Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1957_42525",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1957_42525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1957_42525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1d4ca964.svg";
export { ForwardRef as ReactComponent };